var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegratedPrintBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8636 8.72727H17.9545V9.81818H16.8636V8.72727Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3.27273V19.6364H24.5V0H3.77273L0.5 3.27273ZM9.22621 3.27283V5.45461H15.7717V3.27283H9.22621ZM7.04545 6.54545L4.86364 8.72721V14.1818H8.13636V12H16.8636V14.1818H20.1364V8.72721L17.9545 6.54545H7.04545ZM8.13636 16.3637L10.3182 13.0909H14.6818L16.8636 16.3637H8.13636Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegratedPrintBarcode);
export default __webpack_public_path__ + "static/media/Integrated_PrintBarcode.0a33d10b43c1d9e321d8f3a93ab14c7f.svg";
export { ForwardRef as ReactComponent };